module.exports = __webpack_public_path__ + "img/4.e4950a71.svg";